import React from 'react';
import { Provider } from 'react-redux';
import { ClientContext } from '@thd-nucleus/app-render/dist/client';
import B2BTheme from '@thd-olt-global/b2b-theme';
import { NewRelicBridge } from '@thd-olt-component-react/new-relic-bridge';
import { ThdAnalytics } from '@thd-olt-component-react/thd-analytics';
import { PersistGate } from 'redux-persist/integration/react';
import { whyDidYouRender } from '../wdyr';
import { App } from './App';
import { getRoutes } from './routes';
import history from './app/history';
import configureStore from './app/store/configureStore';
import { Utils } from './app/utils/urlUtils';
import { setConfig, setConfigEnvironment } from './app/actions/configActions';
import { ddoInit, ddoEventInit } from './app/utils/analytics/_digitalData';
import { setGlobalOnErrorHandler } from './pages/onWindowError';
import { getPageDataServer, getUrlData } from './server-utils';

ThdAnalytics.init();
NewRelicBridge.init();
whyDidYouRender.init();

setGlobalOnErrorHandler();

document.addEventListener('DOMContentLoaded', async () => {
  const client = new ClientContext();
  client.setExperienceRoutes(getRoutes());
  if (client.customer.type === 'b2b') {
    client.setTheme({ name: 'b2b', template: B2BTheme });
  }

  window.urlEnvironment = Utils.getEnvironment();
  const { omsId } = getUrlData(window.location.pathname);

  const pageData = await getPageDataServer(client, omsId);
  const hydratedStoreInitialState = { ...pageData };
  const { store, persistor } = configureStore({ ...hydratedStoreInitialState });
  store.dispatch(setConfigEnvironment(window.urlEnvironment));
  store.dispatch(setConfig({ ...pageData?.settings, ...pageData?.thdBreadcrumbInfo }));

  window.ddoInit = ddoInit;
  window.ddoEventInit = ddoEventInit;

  client.render(
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App
          history={history}
          store={store}
          prefetchPip={client.featureSwitches.prefetchPip}
          productPodHoverDelay={client.featureSwitches.productPodHoverDelay}
          pageData={pageData}
        />
      </PersistGate>
    </Provider>
  );
});
